import { getParticipantProps, getScoresProps, getOccurrenceProps, getMarketResultProps, getLeagueNameProps, getRuleDeductionProps } from "../../selection";
import { BetTypes } from "../../../../types";
export const getEventDetailsProps = (betType, selection, state) => {
    return {
        participantNames: getParticipantProps(selection),
        scores: getScoresProps(selection),
        occurrence: getOccurrenceProps(selection.startEventDate, state),
        leagueName: getLeagueNameProps(selection),
        marketResult: betType !== BetTypes.YourBet && selection.gameScore ? getMarketResultProps(selection, state) : undefined,
        ruleDeduction: selection.rule4Deduction ? getRuleDeductionProps(selection) : undefined
    };
};
//# sourceMappingURL=getEventDetailsProps.js.map